import { Component, NgZone, OnDestroy } from "@angular/core";
import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from "@nebular/theme";
import { delay, takeWhile, withLatestFrom } from "rxjs/operators";

import { StateService } from "../../../@core/utils";
import { adminMenu, adminMenuEN, shipOwnerLogo } from "../../../shared/constants/constants";

@Component({
  selector: "ngx-sample-layout",
  styleUrls: ["./sample.layout.scss"],
  templateUrl: "./sample.html",
})
export class SampleLayoutComponent implements OnDestroy {
  subMenu: NbMenuItem[] = [
    {
      title: "PAGE LEVEL MENU",
      group: true,
    },
    {
      title: "Buttons",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/buttons",
    },
    {
      title: "Grid",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/grid",
    },
    {
      title: "Icons",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/icons",
    },
    {
      title: "Modals",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/modals",
    },
    {
      title: "Typography",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/typography",
    },
    {
      title: "Animated Searches",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/search-fields",
    },
    {
      title: "Tabs",
      icon: "ion ion-android-radio-button-off",
      link: "/pages/ui-features/tabs",
    }
  ];
  layout: any = {};
  sidebar: any = {};

  private alive = true;
  user: IUser;
  currentTheme: string;
  logoLiner: string = "";
  isTruckerGate: boolean = false;
  constructor(
    protected stateService: StateService,
    protected menuService: NbMenuService,
    protected themeService: NbThemeService,
    protected bpService: NbMediaBreakpointsService,
    protected sidebarService: NbSidebarService,
    private ngZone: NgZone
  ) {
    // toggler

    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user["roles"].includes("truckerGate")) {
      this.isTruckerGate = true;
    }
    if (this.user["roles"].includes("liner")) {
      for (const key in shipOwnerLogo) {
        if (Object.prototype.hasOwnProperty.call(shipOwnerLogo, key)) {
          const element = shipOwnerLogo[key];
          this.user["liner"] === key ? (this.logoLiner = element) : null;
        }
      }
    }
    this.stateService
      .onLayoutState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((layout: string) => (this.layout = layout));

    this.stateService
      .onSidebarState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar;
      });

    this.menuService.onItemClick().subscribe(({ item }) => {
      const routesWithParamsOrState = [
        "/user/gate-in-chassis",
        "/user/gate-in-remorque",
        "/user/gate-in",
        "/user/reports/details",
        "/user/plan",
        "/user/parcs",
        "/user/contract/update-operations",
      ];
      // excluding also admin routes
     const ExcludedRoutes= [...adminMenu.map(e=>e.link),...adminMenuEN.map(e=>e.link),...routesWithParamsOrState ]

      // Skip if no link or if link is in routes with params/state
      if (!item.link || ExcludedRoutes.includes(item.link)) return;
      this.alive = false;
      // Navigate outside Angular for instant feel
      this.ngZone.runOutsideAngular(() => {
        let url = item.link;
        // Check if URL already has hash
        if (!url.includes("#")) {
          // Dynamically add hash before navigating
          url = url.startsWith("/") ? `/#${url}` : `/#/${url}`;
        }
        // Now navigate
        window.location.href = `${window.location.origin}${url}`;
      });
    });
    const isBp = this.bpService.getByName("is");
    this.menuService
      .onItemSelect()
      .pipe(
        takeWhile(() => this.alive),
        withLatestFrom(this.themeService.onMediaQueryChange()),
        delay(20),
      )
      .subscribe(
        ([item, [bpFrom, bpTo]]: [
          any,
          [NbMediaBreakpoint, NbMediaBreakpoint]
        ]) => {
          if (bpTo.width <= isBp.width) {
            this.sidebarService.collapse("menu-sidebar");
          }
        },
      );

    this.themeService
      .getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe((theme) => {
        this.currentTheme = theme.name;
      });
  }

  toggleCompact() {
    this.sidebarService.toggle(true, "menu-sidebar");
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
